var _rect, _text, _text2, _line, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObianFig2PostmortemArc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 560",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 560,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Four releases to kill one bug")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Issue #87: pages rendered on Linux X11/XFCE, then some part of the app stopped taking clicks")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 130,
    x2: 1120,
    y2: 130,
    stroke: "#E2E8E4",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 130,
    r: 7,
    fill: "#DC2626"
  }), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 112,
    fontSize: 14,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle",
    fontFamily: "Consolas, monospace"
  }, "0.1.8"), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 156,
    width: 220,
    height: 150,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 182,
    fontSize: 11.5,
    fontWeight: 600,
    fill: "#DC2626"
  }, "ALL CLICKS DEAD"), /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 204,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "overlay pass-through was"), /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 220,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "recursive, so it also killed"), /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 236,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "the content webview's input"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 130,
    r: 7,
    fill: "#DC2626"
  }), /*#__PURE__*/React.createElement("text", {
    x: 420,
    y: 112,
    fontSize: 14,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle",
    fontFamily: "Consolas, monospace"
  }, "0.1.10"), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 156,
    width: 220,
    height: 150,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 352,
    y: 182,
    fontSize: 11.5,
    fontWeight: 600,
    fill: "#DC2626"
  }, "CHROME DIES LATER"), /*#__PURE__*/React.createElement("text", {
    x: 352,
    y: 204,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "input shape set on the"), /*#__PURE__*/React.createElement("text", {
    x: 352,
    y: 220,
    fontSize: 11.5,
    fill: "#4A5F56",
    fontFamily: "Consolas, monospace"
  }, "gdk::Window, wiped at the"), /*#__PURE__*/React.createElement("text", {
    x: 352,
    y: 236,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "next size-allocate. Hidden:"), /*#__PURE__*/React.createElement("text", {
    x: 352,
    y: 252,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "the QA domain rendered with"), /*#__PURE__*/React.createElement("text", {
    x: 352,
    y: 268,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "no content webview present"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 690,
    cy: 130,
    r: 7,
    fill: "#DC2626"
  }), /*#__PURE__*/React.createElement("text", {
    x: 690,
    y: 112,
    fontSize: 14,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle",
    fontFamily: "Consolas, monospace"
  }, "0.1.11"), /*#__PURE__*/React.createElement("rect", {
    x: 606,
    y: 156,
    width: 220,
    height: 150,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 622,
    y: 182,
    fontSize: 11.5,
    fontWeight: 600,
    fill: "#DC2626"
  }, "FIX EXPOSES THE BUG"), /*#__PURE__*/React.createElement("text", {
    x: 622,
    y: 204,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "IPFS pages moved to the"), /*#__PURE__*/React.createElement("text", {
    x: 622,
    y: 220,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "native webview: the reported"), /*#__PURE__*/React.createElement("text", {
    x: 622,
    y: 236,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "links now work, and the"), /*#__PURE__*/React.createElement("text", {
    x: 622,
    y: 252,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "latent 0.1.10 chrome bug"), /*#__PURE__*/React.createElement("text", {
    x: 622,
    y: 268,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "finally has a trigger"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 960,
    cy: 130,
    r: 7,
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("text", {
    x: 960,
    y: 112,
    fontSize: 14,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle",
    fontFamily: "Consolas, monospace"
  }, "0.1.12"), /*#__PURE__*/React.createElement("rect", {
    x: 876,
    y: 156,
    width: 220,
    height: 150,
    rx: 10,
    fill: "#F7FAF8",
    stroke: "#16A34A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 892,
    y: 182,
    fontSize: 11.5,
    fontWeight: 600,
    fill: "#16A34A"
  }, "BOTH WORK, CONFIRMED"), /*#__PURE__*/React.createElement("text", {
    x: 892,
    y: 204,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "input shape set with the"), /*#__PURE__*/React.createElement("text", {
    x: 892,
    y: 220,
    fontSize: 11.5,
    fill: "#4A5F56",
    fontFamily: "Consolas, monospace"
  }, "gtk::Widget method, which"), /*#__PURE__*/React.createElement("text", {
    x: 892,
    y: 236,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "GTK stores and re-applies"), /*#__PURE__*/React.createElement("text", {
    x: 892,
    y: 252,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "across every relayout"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 336,
    width: 1030,
    height: 76,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#7C3AED",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 364,
    fontSize: 12,
    fontWeight: 600,
    fill: "#7C3AED"
  }, "ROOT CAUSE"), /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 388,
    fontSize: 12.5,
    fill: "#1A2F2A"
  }, "GtkOverlay re-asserts the overlay child's input region at every size-allocate: a window-level shape is wiped, a widget-level shape survives."))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 428,
    width: 1030,
    height: 92,
    rx: 10,
    fill: "#F7FAF8",
    stroke: "#16A34A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 456,
    fontSize: 12,
    fontWeight: 600,
    fill: "#16A34A"
  }, "SO IT CANNOT RETURN"), /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 480,
    fontSize: 12.5,
    fill: "#1A2F2A"
  }, "A regression-guard test fails the build if the code reverts to the window-level method, on every platform."), /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 502,
    fontSize: 12.5,
    fill: "#1A2F2A"
  }, "The release QA checklist now requires clicking the chrome after a content webview loads, on real X11/XFCE."))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObianFig2PostmortemArc);
export default __webpack_public_path__ + "static/media/obian-fig2-postmortem-arc.16cc954d2274da63cf4413d421d80d19.svg";
export { ForwardRef as ReactComponent };